import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardReportModel } from 'src/app/models/dashboard/dashboard-report';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
    selector: 'app-reporting-widget',
    templateUrl: './reporting-widget.component.html',
    styleUrl: './reporting-widget.component.scss',
    standalone: false
})
export class ReportingWidgetComponent {
  reportsListData: DashboardReportModel[] = [
    {
      id: 0,
      name: this.translateService.instant('DASHBOARD.REPORTING.IDD-REPORT'),
      description: this.translateService.instant(
        'DASHBOARD.REPORTING.IDD-REPORT-DESCRIPTION'
      ),
      link: '/reporting-idd',
    },
    {
      id: 1,
      name: this.translateService.instant('DASHBOARD.REPORTING.COMPLIANCE-REPORT'),
      description: this.translateService.instant('DASHBOARD.REPORTING.COMPLIANCE-REPORT-DESCRIPTION'),
      link: '/reporting-compliance'
    }
  ];

  reportsListDataColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.REPORT-NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
      cellTemplate: 'link',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.DESCRIPTION'),
      dataField: 'description',
      dataType: 'string',
      disableFiltering: true,
    },
  ];


  constructor(
    private translateService: TranslateService
  ) {
    
  }
}
